import { tss } from 'tss-react/mui';

export const useStyles = tss.create(() => ({
  chatBox: {
    width: '100%',
    height: '100%',
  },
  chatBoxMessages: {
    padding: '20px 24px',
    width: '100%',
    height: '100%',
    minHeight: '300px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  dialogGridContent: {
    display: 'flex',
    height: '100%',
    minHeight: '300px',
    justifyContent: 'space-between',
    alignContent: 'space-between',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: '8px',
    padding: '40px 24px',
  },
  emptyStateIcon: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: '#f3f4f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px',
  },
  emptyStateTitle: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#374151',
  },
  emptyStateSubtitle: {
    fontSize: '13px',
    color: '#9ca3af',
  },
}));
